<template>
  <v-img
    style="overflow: hidden; height: 100vh"
    :src="require('@/assets/' + background_image)"
    gradient="rgba(0,0,0,.80), rgba(0,0,0,.90)"
  >
    <v-dialog
      v-model="error_dialog"
      transition="dialog-top-transition"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Benutzername oder Passwort falsch!
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container
      fill-height
      fluid
    >
      <v-row
        justify="center"
      >
        <v-col
          cols="12"
          xs="6"
          sm="6"
          md="4"
          lg="4"
          xl="3"
          order-sm="0"
          order="2"
        >
          <v-card
          >
            <v-card-title>
              Links
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row
                >
                  <v-col
                    v-for="(link, index) in links"
                    :key="index"
                    cols="4"
                    align="center"
                  >
                      <v-btn
                        x-large
                        icon
                        @click="openURL(link.url)"
                      >
                        <v-icon
                          x-large
                          :color="link.color"
                        >
                          {{ link.icon }}
                        </v-icon>
                      </v-btn>
                      <br>
                      {{ link.text }}
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          xs="6"
          sm="6"
          md="4"
          lg="4"
          xl="3"
          order="1"
        >
          <v-card
            rounded
          >
            <v-card-title
              class="pa-1"
            >
              <v-img
                :src="require('@/assets/Garbsen_EZ_Feuerwehr_CMYK.jpg')"
              >
                <v-progress-linear
                  v-if="loading"
                  color="grey"
                  indeterminate
                  striped
                  height="10"
                  rounded
                ></v-progress-linear>

              </v-img>
            </v-card-title>
            <v-card-text>
                <v-text-field
                  v-model="username"
                  :rules="[v => !!v || 'Benutzername fehlt!']"
                  label="Benutzername"
                  required
                  autofocus
                  @keydown.enter="do_login"
                ></v-text-field>
                <v-text-field
                  v-model="password"
                  :rules="[v => !!v || 'Password fehlt!']"
                  label="Password"
                  type="password"
                  required
                  @keydown.enter="do_login"
                ></v-text-field>
                <v-btn
                  class="mr-4 primary"
                  :loading="loading"
                  :disabled="loading || username.length === 0 || password.length === 0"
                  @click="do_login"
                >
                  Login
                </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-img>

</template>

<script>
export default {
  name: "LoginView",
  data: () => ({
    valid: true,
    username: '',
    password: '',
    loading: false,
    error_dialog: false,
    background_image: '',
    background_images: [
      "leinestrasse.jpg",
      "lichtstars_garbsen_knaak_5D__8789_.jpg"
    ],
    links: [
      { text: 'SFW', icon: 'mdi-domain', color: 'green darken-2', url: 'https://www.stadtfeuerwehr-garbsen.de'},
      { text: 'Extranet', icon: 'mdi-email', color: 'purple darken-2', url: 'https://www.stadtfeuerwehr-garbsen.de/extranet'},
      { text: 'FeuerOn', icon: 'mdi-fire', color: 'orange  darken-2', url: 'https://feueron.de/feueron/'},
      { text: 'Fileserver', icon: 'mdi-file', color: 'teal  darken-2', url: 'https://intern.stadtfeuerwehr-garbsen.de'}
    ]
  }),
  created() {
    this.background_image = this.background_images[Math.floor(Math.random()*this.background_images.length)];
  },
  methods: {
    openURL(url){
      window.location = url
    },
    validate() {
      //this.$refs.form.validate()
    },
    form_reset() {
      //this.$refs.form.reset()
    },
    resetValidation() {
      //this.$refs.form.resetValidation()
    },
    do_login(){
      this.loading = true
      const payload = {
        u: this.username,
        p: this.password
      }
      const query = this.$store.state.general.api_host + '/login'
      fetch(query, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
      .then((response) => {
        if (response.status === 200) {
          return response.text()
        }  else {
          throw new Error(response.status)
        }
      })
      .then((response) => decodeURIComponent(response))
      .then((response) => JSON.parse(response))
      .then((data) => {
        this.$store.commit('login', data.access_token)
        this.form_reset()
        this.$router.push("/")
        this.loading = false
      })
      .catch((error) => {
        if(error.message === '400' || error.message === '401') {
          console.log("Benutzername oder Passwort falsch")
          this.error_dialog = true
          setTimeout(() => (this.error_dialog = false), 3000)
        } else {
          console.log(error)
        }
        this.loading = false
      })
    }
  }
};
</script>

<style scoped>

</style>
